import { render, staticRenderFns } from "./Sadmin.vue?vue&type=template&id=06487834&scoped=true&"
import script from "./Sadmin.vue?vue&type=script&lang=js&"
export * from "./Sadmin.vue?vue&type=script&lang=js&"
import style0 from "./Sadmin.vue?vue&type=style&index=0&id=06487834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06487834",
  null
  
)

export default component.exports